// extracted by mini-css-extract-plugin
export default {"logo":"LogoView_logo__OPCeI"};